import React, {
  useMemo,
  useRef,
} from 'react';
import {
  InsuranceDTO,
} from 'dtos';
import {
  InsuranceSlot,
} from 'dtos/insuranceSlot';
import InsuranceEligibility from 'pages/Dashboard/components/InsuranceEligibility';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  formatMoney,
} from '@populateui/utils';
import ToolTip from 'core/components/Tooltip';
import LocalPoliceRoundedIcon from '@mui/icons-material/LocalPoliceRounded';
import {
  getInsuranceBasicInfo,
} from 'utils/misc';
import {
  InsuranceWithPatient,
} from 'pages/Dashboard/pages/Appointments/pages/List/components/Details/PatientInsuranceList/List';

function InsuranceName({ payerEntry, insuranceName, insuranceSlot }: InsuranceDTO) {
  const basicInfo = useMemo(
    () => getInsuranceBasicInfo(payerEntry ?? {}),
    [payerEntry],
  );

  const infoRef = useRef<HTMLDivElement>(null);
  const nameRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col gap-1 w-[90%]">
      <div className="flex items-center gap-1">
        {insuranceSlot === InsuranceSlot.Primary && (
        <ToolTip title="Primary Insurance">
          <LocalPoliceRoundedIcon className="!w-4 !h-4 !text-blue-500" />
        </ToolTip>
        )}
        <ToolTip title={insuranceName} ref={nameRef} auto>
          <span className="truncate" ref={nameRef}>{insuranceName}</span>
        </ToolTip>
      </div>
      <ToolTip title={basicInfo} ref={infoRef} auto>
        <div className="text-[10px] font-semibold text-gray-600 truncate" ref={infoRef}>
          {basicInfo}
        </div>
      </ToolTip>
    </div>
  );
}

const columns: ColumnDef<InsuranceWithPatient>[] = [{
  id: 'insuranceName',
  accessorKey: 'insuranceName',
  header: 'Insurance Name',
  size: 260,
  cell: ({ row }) => (
    <InsuranceName {...row.original} />
  ),
}, {
  id: 'copay',
  accessorKey: 'copay',
  header: 'Copay',
  size: 56,
  cell: ({ row }) => formatMoney(row.original?.copay ?? 0),
}, {
  id: 'actions',
  accessorKey: 'actions',
  header: '',
  meta: { autoSized: true },
  cell: ({ row }) => (
    <div className="flex justify-end flex-1" key={`container-${row.original.insuranceId}`}>
      <InsuranceEligibility
        key={row.original.insuranceId}
        insurance={row.original}
        patient={row.original.patient}
        startDate={row.original.startDate}
        endDate={row.original.endDate}
        shortView
        tooltip="Check Eligibility"
        classes={{
          lastChecked: '!flex-row-reverse !gap-1 !space-x-0',
        }}
      />
    </div>
  ),
}];

export default columns;
